import { render } from "./ListNote.vue?vue&type=template&id=5dc0a166&ts=true"
import script from "./ListNote.vue?vue&type=script&lang=ts"
export * from "./ListNote.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__